// extracted by mini-css-extract-plugin
export default {"rail":"CoachRail_rail__sO4Fd"};